export const monthList = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const GOOGLE_PLACE = {
  fields: ["address_components", "geometry", "formatted_address"],
  types: ["geocode", "establishment"],
};

export const validImages = ["image/jpeg", "image/png", "image/jpg"];

export const validDocs = [
  "image/jpeg",
  "image/png",
  "image/jpg",
  "application/pdf",
];

export const static_user_image =
  "https://d2j40m88aovabi.cloudfront.net/wp-content/uploads/2019/10/18095654/user.png";
export const static_doc_imge =
  "https://images.pexels.com/photos/2422404/pexels-photo-2422404.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";

export const VALIDATIONS_ERROR_MESSAGES = {
  FILE_NOT_FOUND: "File not found",
  IMAGE_ONLY: "Please upload images only",
  GIT_NAME: "The name field is required",
  GIT_NAME_VALID: "Please enter valid name",
  GIT_NAME_LENGTH: "The name may not be greater than 50 characters",
  GIT_INVALID_CAPTCHA: "Invalid captcha",
  GIT_SUCCESS: "Your request has been successfully submitted.",
  GIT_FAIL: "Please fill all the fields",
  GIT_EMAIL: "Please enter valid email",
  GIT_PHONENO: "Please enter valid phone number",
  PROMOCODE: "Please enter the promo code",
  PROMO_CODE_LENGTH: "The promo code may not be greater than 20 characters",
  KLAVIYO_SUCCESS: "Your subscription request has been recieved.",
  VALID_ADDRESS: "Please enter valid address",
};

export const date_format = {
  SHORT_DATE: "MMM D, YYYY",
  BOOKING_DATE: "MMM D, YYYY [at] hh:mm A",
  BOOKING_DATE_RESERVATION: "MMM D, YYYY - hh A",
  DATE: "MM/DD",
  YEAR: "YY",
};

export const page_limit = 10;
export const page_limit_mytrip = 9;
export const page_limit_blog = 4;
export const page_limit_wishlist = 8;
export const REQUIRE_OTP = "OTP Required!";
export const ALREADY_BOOKED = "You already completed your booking";
export const VALID_START_DATE = "Start date should be today or greater than";
export const FIRST_NAME_LENGTH =
  "The first name may not be greater than 50 characters";
export const VALID_FIRST_NAME = "Please enter valid first name";

export const cardElementStyles = {
  base: {
    fontSize: "16px",
    color: "#222222",
    fontFamily: "HelveticaNeue-medium, sans-serif",
    fontSmoothing: "antialiased",
    "::placeholder": {
      color: "#777777",
    },
  },
  invalid: {
    color: "#dc3545",
  },
};

export const ALREADY_SAVED_WISHLIST = "Car already in your wishlist";
export const SAVED_WISHLIST = "Car saved to the wishlist";
export const REMOVED_WISHLIST = "Car removed from the wishlist";

export const closingTime = {
  weekEnd: new Date().setHours(16), // 4PM
  weekDays: new Date().setHours(18), // 6PM
};

export const operatingHoursNote =
  "Note: Hours of Operation: Monday - Friday: 8 AM - 8 PM | Saturday - Sunday: 8 AM - 6 PM";

export const GOOGLE_TAG_MANAGER_ID = "GTM-5JGZZZZ";
export const FACEBOOK_PIXEL_ID = "849795385122652";
export const SITE_DOMAIN_NAME = "https://www.falconcarrental.com";
export const IS_WEBP_LOADED = false;
export const COOKIE_NOTIFICATION_TEXT =
  "This site uses cookies from Google to deliver its services and to analyze traffic.";
export const GOOGLE_TAG_MANAGER_ID_THANK_YOU = "AW-945888477";

export const TOOLTIP_MESSAGE = {
  PICK_UP_LOCATION:
    "Pick up the vehicle from our location at 499 N Canon Dr, Beverly Hills, CA 90210.",
  DROP_OFF_LOCATION:
    "Have your vehicle delivered to your desired location for ultimate convenience.",
  DROP_OFF_LOCATION_1:
    "Delivery windows: Weekdays 8am–8pm, Weekends 8am–6pm. For deliveries outside these time windows, please contact our office for arrangements (additional charges will apply).",
  DROP_OFF_LOCATION_2:
    "Complimentary delivery available for Beverly Hills, West Hollywood, Century City, and Westwood.",
  ONE_WAY_LOCATION:
    "Return the vehicle at a location different from the initial pickup/delivery location.",
  OFFER_CARD_DISCOUNT_1:
    "A 15% discount will automatically apply to all reservations of 7 days or more.",
  OFFER_CARD_DISCOUNT_2:
    "A 30% discount will automatically apply to all reservations of 28 days or more.",
  MIAMI_LOCATION:
    "Pick up the vehicle from our location at 929 Alton Rd, Miami Beach, FL 33139",
  DROP_OFF_MESSAGE_MIAMI:
    "Complimentary delivery available for South Beach, FL 33139.",
  DROP_OFF_LOCATION_1_MIAMI:
    "Delivery windows: 10:00 AM–6:00 PM. For deliveries outside these time windows, please contact our office for arrangements (additional charges will apply).",
  DRIVE_NOW: "Vehicles available for pickup or delivery today, from the time shown.",
};
export const REDIRECT_STATUS = 301;
export const VEHICLE_UNAVAILABLE_ERROR =
  " This car is temporarily unavailable. Please try searching for another car.";
export const ALLOWED_PAGES = ["brand", "category", "home"];
